import { render, staticRenderFns } from "./RegistrationRequestBillingDetails.vue?vue&type=template&id=51f8f06a"
import script from "./RegistrationRequestBillingDetails.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestBillingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports